import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: { title: '自述文件' },
            children: [
                {   // 废弃
                    path: '/class_manage',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/sys_settings/class_manage.vue'),
                    meta: { title: '部门管理' }
                },
                {
                    path: '/role_manage',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/sys_settings/role_manage.vue'),
                    meta: { title: '角色管理' }
                },
                {
                    path: '/account_manage',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/sys_settings/account_manage.vue'),
                    meta: { title: '账号管理' }
                },
                {
                    path: '/store_manage',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/sys_settings/store_manage.vue'),
                    meta: { title: '门店管理' }
                },
                {
                    path: '/storeEquipment_manage',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/equipmentManagement'),
                    meta: { title: '设备列表' }
                },
                {   // 废弃
                    path: '/offline_staff',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/sys_settings/offline_staff.vue'),
                    meta: { title: '岗下员工' }
                },
                {
                    path: '/wx_manage',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/sys_settings/wx_manage.vue'),
                    meta: { title: '小程序配置' }
                },
                {
                    path: '/indent_order',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/order_manage/indent_order.vue'),
                    meta: { title: '代购订单' }
                },
                {
                    path: '/device_order',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/order_manage/device_order.vue'),
                    meta: { title: '设备订单' }
                },
                {
                    path: '/active_order',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/order_manage/active_order.vue'),
                    meta: { title: '活动订单' }
                },
                {
                    path: '/vip_order',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/order_manage/vip_order.vue'),
                    meta: { title: '活动订单' }
                },
                {
                    path: '/member_list',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/member_center/member_list.vue'),
                    meta: { title: '会员列表' }
                },
                {
                    path: '/menber_base_info',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/member_center/menber_base_info.vue'),
                    meta: { title: '基础信息' }
                },
                {
                    path: '/ndc_patient_list',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/member_center/ndc_patient_list.vue'),
                    meta: { title: '慢病会员' }
                },
                {
                    path: '/user_info_manage',
                    name: 'user_info_manage',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/common/user/user_info_manage.vue'),
                    // component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/member_detail/index.vue'),
                    meta: { title: '会员基础信息' }
                },
                {
                    path: '/verification_manage',
                    name: 'verification_manage',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/cancelAfterVerification'),
                    meta: { title: '核销记录' }
                },
                {
                    path: '/payMenber',
                    name: 'payMenber',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/payMenber'),
                    meta: { title: '卡券核销' }
                },
                {
                    path: '/record',
                    name: 'record',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/record'),
                    meta: { title: '实体卡核销' }
                },
                {
                    path: '/banner_manage',
                    name: 'banner_manage',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/oper_center/banner_manage.vue'),
                    meta: { title: 'banner管理' }
                },
                {
                    path: '/healthManage',
                    component: () => import('../components/page/medicalTeamManage/healthManage/index'),
                    name: 'health_manage',
                    meta: { title: '健康管理师管理' },
                    hidden: true
                },
                {
                    path: '/healthManage_detail',
                    component: () => import('../components/page/medicalTeamManage/healthManage/doctorDetail'),
                    name: 'healthManage_detail',
                    meta: { title: '健康管理师管理详情' },
                    hidden: true
                },
                {
                    path: '/storeManage',
                    component: () => import('../components/page/medicalTeamManage/storeManage'),
                    name: 'storeManage',
                    meta: { title: '门店管理' },
                    hidden: true
                },

                {
                    path: '/404',
                    component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
                    meta: { title: '404' }
                },
                {
                    path: '/403',
                    component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
                    meta: { title: '403' }
                },
                {
                    path: '/my_home',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/my_home.vue'),
                    meta: { title: '首页' }
                },
                {
                    path: '/qrcode',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/qrcode.vue'),
                    meta: { title: '二维码' }
                },
            ]
        },
        {
            path: '/login',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/login.vue'),
            meta: { title: '登录' }
        },
        {
            path: '/route-login',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/routeLogin.vue'),
            meta: { title: '登录' }
        },
        {
            path: '*',
            redirect: '/404'
        },
        {
            path: '/getPreAuthorizationPage',
            component: () => import(/* webpackChunkName: "login" */ '../components/common/getPreAuthorizationPage.vue'),
            meta: { title: '授权' }
        },
        {
            path: '/AuthorizationRedirectUri',
            component: () => import(/* webpackChunkName: "login" */ '../components/common/AuthorizationRedirectUri.vue'),
            meta: { title: '回调' }
        }
    ]
});
